import { useNavigate } from "react-router-dom";
import { Flame, ChevronLeft } from "lucide-react";

function LegalShell({ title, children }) {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="flex items-center justify-between px-5 md:px-10 py-4 border-b border-border">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => nav("/")}>
          <Flame className="text-primary" size={22} strokeWidth={2.5} />
          <span className="font-display text-xl">ROX<span className="text-primary">LAB</span></span>
        </div>
        <button data-testid="legal-back-btn" onClick={() => nav(-1)} className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
          <ChevronLeft size={16} /> Retour
        </button>
      </header>
      <main className="max-w-2xl mx-auto px-5 py-10">
        <h1 className="font-display text-3xl sm:text-4xl mb-8">{title}</h1>
        <div className="space-y-6 text-sm text-muted-foreground leading-relaxed [&_h2]:text-foreground [&_h2]:font-display [&_h2]:text-xl [&_h2]:mb-2 [&_h2]:mt-6 [&_b]:text-foreground">
          {children}
        </div>
        <p className="text-xs text-muted-foreground mt-12">Dernière mise à jour : juin 2026.</p>
      </main>
    </div>
  );
}

export default function Legal() {
  return (
    <LegalShell title="Mentions légales">
      <section data-testid="legal-content">
        <h2>Éditeur du site</h2>
        <p>Le service <b>Roxlab</b> (coaching sportif et nutritionnel spécialisé HYROX) est édité par l'exploitant du site. Pour toute question relative à l'édition, contactez-nous via l'adresse de support indiquée dans l'application.</p>

        <h2>Directeur de la publication</h2>
        <p>Le responsable de la publication est le représentant légal de l'éditeur de Roxlab.</p>

        <h2>Hébergement</h2>
        <p>L'application est hébergée sur une infrastructure cloud managée. Les données sont traitées et stockées conformément à la réglementation applicable.</p>

        <h2>Propriété intellectuelle</h2>
        <p>L'ensemble des contenus (textes, programmes générés, éléments graphiques, marque Roxlab) est protégé par le droit de la propriété intellectuelle. Toute reproduction non autorisée est interdite. HYROX® est une marque de son propriétaire respectif ; Roxlab n'est pas affilié à l'organisateur officiel des compétitions HYROX.</p>

        <h2>Responsabilité — santé</h2>
        <p>Les programmes d'entraînement et recommandations nutritionnelles fournis par Roxlab sont générés à titre informatif et ne constituent <b>pas un avis médical</b>. Consultez un professionnel de santé avant de débuter tout programme, en particulier en cas de blessure, de pathologie ou de doute. Vous restez seul responsable de l'usage que vous faites des recommandations.</p>

        <h2>Paiement</h2>
        <p>Les abonnements sont gérés via notre prestataire de paiement Stripe. Aucune donnée complète de carte bancaire n'est stockée sur nos serveurs.</p>
      </section>
    </LegalShell>
  );
}
